import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import { Builder } from "@builder.io/react";
import { BuilderComponent } from "@builder.io/react";
import { builderClient } from "../../../utils/builder";
import useNewOrReturningCustomer from "@/helpers/hooks/useNewOrReturningCustomer";
import { getUserTierInfo } from "@/helpers/yotpoHelper";
import { useSelector } from "react-redux";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";

const HeaderGlobalBanner = (props) => {
  const [builderContentJson, setBuilderContentJson] = useState(null);
  const router = useRouter();
  const newOrReturningCustomer = useNewOrReturningCustomer();
  const customerRewardLevel =  getUserTierInfo();
  const isApp = useSelector((state) => state.pwa.is_PWA);
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const isTablet = useMediaQuery("(min-width: 601px) and (max-width: 1024px)");
  const isMobile = useMediaQuery("(max-width: 600px)");

  useEffect(() => {
    try{
      if(newOrReturningCustomer) {
        builderClient
        .get("header", {
          userAttributes: {
            urlPath: router.asPath,
            customerType: newOrReturningCustomer,
            rewardLevel: customerRewardLevel,
            app: isApp
          },
        })
        .promise()
        .then((res)=>{
          setBuilderContentJson(res)
          res?.data?.blocks?.map(ele=>{
            if(ele?.component?.name=='Global banner'){
              let bgColor = ele?.component?.options?.backgroundColor;
              let fontColor = ele?.component?.options?.fontColor;
              if(bgColor){
                props.setHeaderColor({"background":bgColor})
              }
              if(fontColor){
                props.setHeaderColor((prev)=>({...prev ,"fontColor":fontColor}));
              }
            }
          })
        });
      }
    }catch(err){
      reportError("Builder global banner error : ",err)
    }
  }, [router.asPath, newOrReturningCustomer,customerRewardLevel, isApp]);

  return <div className="global-banner" style={{color:props.color}}>{builderContentJson ? <BuilderComponent model="header" content={builderContentJson} />: 
  <div
  className="x-small-md x-small-sm x-small-xs default_msg"
  id="promotional-msg" tabIndex={0}>{
  isMobile || isTablet ? <><strong>15% OFF</strong> YOUR FIRST APP ORDER*</>: 
  isDesktop?<>ENJOY <strong>15% OFF</strong> YOUR FIRST APP ORDER (exclusions apply).</>:
  <></>
  }</div> }</div>;
};


const GlobalBanner = dynamic(async () => {
  return (await import("./GlobalBanner")).default;
});

Builder.registerComponent(GlobalBanner, {
  name: "Global banner",
  inputs: [
    {
      name: "bannerMessages",
      type: "list",
      helperText: "Banner messages for header",
      subFields:[
       {
         name:"desktopMessage",
         type:"longText",
         helperText:"Add desktop message for slide"
       },
       {
        name: "desktopMessageLink",
        type: "url",
        helperText: "Desktop message specific URL",
       },
       {
        name:"tabletMessage",
        type:"longText",
        helperText:"Add tablet message for slide"
        },
        {
        name: "tabletMessageLink",
        type: "url",
        helperText: "Tablet message specific URL",
        },
        {
          name:"mobileMessage",
          type:"longText",
          helperText:"Add mobile message for slide"
        },
        {
         name: "mobileMessageLink",
         type: "url",
         helperText: "Mobile message specific URL",
        },
      ],
    },
    {
        name: "backgroundColor",
        type: "string",
        helperText: "Background color for entire banner",
    },
    {
        name: "fontColor",
        type: "string",
        helperText: "Font color for entire banner",
    },
    {
        name: "transitionType",
        type: "string",
        defaultValue: "Slide",
        enum: ["Slide","Fade"],
        helperText: "Transition for global banner slides",
    },
  ],
});

export default HeaderGlobalBanner;